import React from "react";
import "./About.css";
import AboutImage from "../images/about.jpg";

const About = () => {
  return (
    <section className="about">
      <div className="about-container">
        <h1 className="page-title">About Me</h1>
        <div className="about-content">
          <div className="about-image">
            <img
              src={AboutImage}
              alt="About image"
            />
          </div>
          <div className="about-text">
            <h2>Passionate Engineering Student</h2>
            <p>
              I am a dedicated engineering student with a passion for technology
              and innovation. My journey in engineering has equipped me with
              strong problem-solving skills and the ability to think critically
              about complex problems.
            </p>
            <p>
              I believe in continuous learning and staying updated with the
              latest technological advancements. My goal is to leverage my
              skills to create solutions that make a positive impact on society.
            </p>
            <div className="about-info">
              <div className="info-item">
                <span className="label">Name:</span>
                <span className="value">Bhanu Prakash Kollati</span>
              </div>
              <div className="info-item">
                <span className="label">Email:</span>
                <span className="value">bhanuprakash21624@gmail.com</span>
              </div>
              <div className="info-item">
                <span className="label">Location:</span>
                <span className="value">Bhimavaram, Andhra Pradesh</span>
              </div>
              <div className="info-item">
                <span className="label">Education:</span>
                <span className="value">B.Tech</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;